export default "__VITE_ASSET__Crv8XQ38__"